import { z } from 'zod';
import { ImageAssetSchema } from '../app/ui/imageAsset';
import { I18nStringSchema } from '../core/i18n';
/*
  Effects
*/
export const EffectLevelSchema = z.enum([
    'XS',
    '-XS',
    'S',
    '-S',
    'M',
    '-M',
    'L',
    '-L',
    'XL',
    '-XL'
]);
const EffectCategorySchema = z.object({
    id: z.string(),
    name: I18nStringSchema,
    categoryColor: z.string(),
    categoryTextColor: z.string(),
    progressHoverColor: z.string(),
    sortOrder: z.number()
});
export const BaseEffectSchema = z.object({
    key: z.string(),
    nameI18n: I18nStringSchema,
    definitionI18n: I18nStringSchema,
    sortOrder: z.number(),
    deprecated: z.boolean(),
    category: EffectCategorySchema,
    icon: ImageAssetSchema
});
/*
  Costs
*/
export const CostSchema = z.object({
    key: z.string(),
    nameI18n: I18nStringSchema,
    definitionI18n: I18nStringSchema,
    estimatedPercentOfTotal: z.number().min(0.01).max(1),
    sortOrder: z.number(),
    deprecated: z.boolean(),
    category: z.object({
        progressColor: z.string()
    })
});
//# sourceMappingURL=effect.js.map